import React, { useCallback, useState, useContext } from 'react';
import { Button, Layer, Box } from 'grommet';
import { Close } from 'grommet-icons';
import { usePaywall } from '@components/Paywall/paywall.hooks';
import { PaywallContext } from '@components/Paywall/paywall.types';
import { ViewerEntitlementStatus } from '@components/Paywall/paywall.types';
import { analytics } from '@services/analytics';

import { UserContext } from '@services/Session';

import Paywall from '@components/Paywall/Paywall';
import PaywallLock from '@components/Paywall/PaywallLock';

interface MonetizedViewButtonProps {
  handleActiveClip?: (activeClip: string, teamPlayerId: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clip: any;
  entitlementStatus?: ViewerEntitlementStatus;
  teamId?: string;
  gameId?: string;
  activeClip?: (clip: unknown) => void;
  displayVideo?: (show: boolean) => void;
}

const MonetizedViewButton: React.FC<MonetizedViewButtonProps> = ({
  clip,
  gameId,
  activeClip = () => {},
  displayVideo = () => {},
  entitlementStatus,
}) => {
  const userStore = useContext(UserContext);
  const [showLockModal, setShowLockModal] = useState(false);
  const {
    isPaywallActive,
    handlePaywallOpen,
    handlePaywallClose,
    handleUnlockAccess,
  } = usePaywall(PaywallContext.VIEW_BUTTON);

  const handleViewClip = useCallback(
    () => {
      analytics.track('Game Page Clip Clicked', {
        gameId: gameId,
        clipId: clip.id,
        loggedIn: !!userStore.authUser,
        sport: 'vb',
      });
      switch (entitlementStatus) {
        case ViewerEntitlementStatus.NOT_ENTITLED_LOGGED_IN:
          handlePaywallOpen();
          break;
        case ViewerEntitlementStatus.NOT_ENTITLED_LOGGED_OUT:
          setShowLockModal(true);
          break;
        case ViewerEntitlementStatus.ENTITLED:
          activeClip(clip);
          displayVideo(true);
          break;
        default:
          break;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      <Button
        plain
        color="secondary-2"
        label="View"
        onClick={() => {
          handleViewClip();
        }}
      />
      <Paywall
        context={PaywallContext.VIEW_BUTTON}
        isOpen={isPaywallActive}
        onClose={() => handlePaywallClose()}
        onUnlockAccess={(term) => handleUnlockAccess(term)}
      />
      {showLockModal && (
        <Layer
          onEsc={() => setShowLockModal(false)}
          onClickOutside={() => setShowLockModal(false)}
        >
          <Box pad="medium">
            <Box direction="row" justify="end" fill="horizontal">
              <Button
                icon={<Close />}
                onClick={() => setShowLockModal(false)}
              />
            </Box>
            <PaywallLock
              mode="game"
              isLoggedIn={!!userStore.authUser}
              isPrivate={false}
            />
          </Box>
        </Layer>
      )}
    </>
  );
};
export default MonetizedViewButton;
